<div class="main-container">
  @if (!accepted) {
    <div>
      <div class="title-container">
        <h1>{{ getMessage() }}</h1>
      </div>
      <div class="content-container">
        @if (
          seatInvitation.invitationIsInvited() ||
          seatInvitation.invitationIsAccepted()
        ) {
          <div class="max-width-container invitation-details">
            @if (seatInvitation.invitationIsInvited()) {
              <p>
                If you are able to participate, please accept the invitation
                below. If not, please decline the invitation. Thank you!
              </p>
            }
            <div class="team-details">
              <div class="header">
                <span>{{
                  this.seatInvitation.publicTeamName
                    ? this.seatInvitation.publicTeamName
                    : this.seatInvitation.teamName
                }}</span>
              </div>
              <div class="sub-header">
                <span>Position: {{ seatInvitation.positionTitle }}</span>
                @if (seatInvitation.dateRange.hasAnyDates()) {
                  <span
                    ><span
                      ><br />{{
                        seatInvitation.dateRange.toString('mediumDate', 'utc')
                      }}</span
                    ></span
                  >
                }
              </div>
              @if (seatInvitation.invitationIsAccepted()) {
                <div class="accepted-invitation-check-container">
                  <span>ACCEPTED</span>
                </div>
              }
              @if (seatInvitation.hasTeamDescription()) {
                <div class="team-description">
                  <span
                    [innerHTML]="seatInvitation.teamDescription | safeHtml"
                  ></span>
                </div>
              }
            </div>
          </div>
        }
        @if (seatInvitation.invitationIsInvited()) {
          <div class="disclaimers-collection-container max-width-container">
            @for (disclaimer of disclaimers; track disclaimer) {
              <div
                class="disclaimer-container"
                fxLayout="column"
                fxLayoutGap="5px"
              >
                <span class="disclaimer-title">{{ disclaimer.title }}</span>
                <div
                  class="disclaimer-text"
                  [innerHTML]="disclaimer.text | safeHtml"
                ></div>
                @if (disclaimer.hasDownloadableFile) {
                  <div class="download-disclaimer-container">
                    <button
                      mat-button
                      color="primary"
                      (click)="downloadDisclaimer(disclaimer)"
                      aria-label="Download Disclaimer"
                    >
                      <mat-icon color="primary" class="md-18"
                        >file_download</mat-icon
                      >
                      DOWNLOAD PDF
                    </button>
                  </div>
                }
                <div class="acknowledgement-container">
                  <mat-checkbox
                    [(ngModel)]="disclaimer.isAcknowledged"
                    color="primary"
                    ><span class="disclaimer-acknowledgement-text">{{
                      disclaimer.acknowledgementText
                    }}</span></mat-checkbox
                  >
                </div>
              </div>
            }
          </div>
        }
        @if (seatInvitation.invitationIsInvited()) {
          <div class="action-buttons max-width-container">
            <button
              (click)="acceptInvitation()"
              mat-button
              color="primary"
              class="mat-flat-button"
              [disabled]="!allDisclaimersAcknowledged()"
            >
              Accept Invitation
            </button>
            <button
              (click)="declineInvitation()"
              mat-button
              class="mat-flat-button decline-button"
            >
              Decline Invitation
            </button>
          </div>
        }
      </div>
    </div>
  }
  @if (accepted) {
    <div>
      <div class="title-container" fxLayout fxLayoutAlign="center center">
        <h1>Thanks for accepting the invitation!</h1>
      </div>
      <div class="content-container">
        <p>
          We've sent you a confirmation email. Thank you in advance for your
          participation.
        </p>
      </div>
    </div>
  }
</div>
